import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { configureSentry } from "./Sentry/configureSentry.ts";
import { AuthCtxProvider } from "./Auth/AuthCtxProvider.tsx";
import { Auth0ProviderWithNavigate } from "./Auth/Auth0ProviderWithNavigate.tsx";
import { AdminSideBarCtxProvider } from "./UI/Admin/AdminSideBarCtxProvider.tsx";
import { BrowserRouter } from "react-router";
import { SWRConfig } from "swr";
import * as Sentry from "@sentry/react";
configureSentry();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <Auth0ProviderWithNavigate>
        <AuthCtxProvider>
          <AdminSideBarCtxProvider>
            <SWRConfig
              value={{
                onError: (error) => {
                  Sentry.captureException(error);
                },
              }}
            >
              <App />
            </SWRConfig>
          </AdminSideBarCtxProvider>
        </AuthCtxProvider>
      </Auth0ProviderWithNavigate>
    </BrowserRouter>
  </StrictMode>,
);
